<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">推奨環境</li>
    </ol>
  </nav>
  <div class="container">

      <div class="top--section">
          <Browser/>
      </div>
  </div>
</template>
<script setup lang="ts">
import Browser from '@/components/Static/Browser.vue'
</script>


